module.exports = __webpack_public_path__ + "static/media/wellhealth.d3f6ee27.png";